export default "__VITE_PUBLIC_ASSET__e3f07db2__"